import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
} from "@material-ui/core";
import { i18n } from "../../../translate/i18n";

const WA_GREEN = "#00a884";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2), marginBottom: theme.spacing(1) },
  title: { marginBottom: theme.spacing(1), fontWeight: 600 },
  tableRow: { cursor: "pointer" },
  empty: { color: "#888", fontSize: 14 },
}));

const pct = (frac) => `${Math.round((frac ?? 0) * 100)}%`;

const ClientRollupPanel = ({ rollup, onSelectAssistant }) => {
  const classes = useStyles();
  const totals = rollup?.totals;
  const perAssistant = rollup?.perAssistant ?? [];

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.clientSummary")}
      </Typography>
      {perAssistant.length === 0 ? (
        <div className={classes.empty}>
          {i18n.t("aiAssistantStats.empty.noAssistants")}
        </div>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{i18n.t("aiAssistantStats.table.asistente")}</TableCell>
              <TableCell>{i18n.t("aiAssistantStats.table.tipo")}</TableCell>
              <TableCell align="right">{i18n.t("aiAssistantStats.table.enviados")}</TableCell>
              <TableCell align="right">{i18n.t("aiAssistantStats.table.respondieron")}</TableCell>
              <TableCell align="right">{i18n.t("aiAssistantStats.table.tasaResp")}</TableCell>
              <TableCell align="right">{i18n.t("aiAssistantStats.table.reclamos")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {perAssistant.map((a) => (
              <TableRow
                key={a.aiAssistantId}
                hover
                className={classes.tableRow}
                onClick={() => onSelectAssistant?.(a.aiAssistantId)}
              >
                <TableCell>{a.displayName ?? a.name ?? String(a.aiAssistantId)}</TableCell>
                <TableCell>
                  {a.type ? <Chip size="small" label={a.type} /> : "—"}
                </TableCell>
                <TableCell align="right">{a.enviados ?? 0}</TableCell>
                <TableCell align="right">{a.respondieron ?? 0}</TableCell>
                <TableCell align="right">{pct(a.tasaRespuesta)}</TableCell>
                <TableCell align="right">{a.reclamosDetectados ?? 0}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
};

export default ClientRollupPanel;
